export const Products_Action_Types = {
    FETCH_PRODUCTS_START: "products/FETCH_PRODUCTS_START",
    FETCH_PRODUCTS_FAILURE: "products/FETCH_PRODUCTS_FAILURE",
    FETCH_PRODUCTS_SUCCESS: "products/FETCH_PRODUCTS_SUCCESS",
    FETCH_PRODUCTS_OPTION_LIST: "products/FETCH_PRODUCT_OPTIONS_LIST",
    SET_PAGE_SIZE: "products/SET_PAGE_SIZE",
    SET_IS_UPDATED: "products/SET_IS_UPDATED",
    SET_FILTER_SEARCH_STRING: "products/SET_FILTER_SEARCH_STRING"
}